import React from 'react'
import './index.scss'

interface IBtnContentProps {
    resetQuery: () => void
    sureSearch: () => void
}

const BtnContent = (props: IBtnContentProps) => {
    const { resetQuery, sureSearch } = props
    return (
        <div className="searchBtnContent">
            <div className="resetBtn baseBtn" onClick={resetQuery}>
                重置
            </div>
            <div className="sureBtn baseBtn" onClick={sureSearch}>
                确认
            </div>
        </div>
    )
}

export default BtnContent
